<!--
 * @author wendb
 * @date 2023-06-02 11:52
 * @description  用户列表
-->
<template>
  <lsTableLayout :left="250">
    <div slot="nav" >
      <a-row :gutter="24">
        <a-col>
          <!-- 部门树 -->
          <dept-tree
            ref="deptTree"
            :deptOptions="deptOptions"
            :expandedKeys="expandedKeys"
            @select="clickDeptNode"
          />
        </a-col>
      </a-row>
    </div>
    <template #search>
      <ListSearchForm ref="searchForm" @onSearch="onSearch" />
    </template>
    <template #btn>
      <lsStatusButton v-show="false">
        <a-button @click="$refs.createModal.show()" v-hasPermi="['system:user:add']" type="primary">新增</a-button>
        <a-button @click="batchDelete(selectedRowKeys)" v-hasPermi="['system:user:remove']" :disabled="selectedRowKeys.length === 0">删除</a-button>
        <a-button @click="handleExport" v-hasPermi="['system:user:export']">导出</a-button>
        <a-button @click="importExcelHandleOpen" v-hasPermi="['system:user:import']">导入</a-button>
        <a-button @click="importTemplate">下载模板</a-button>
        <a-button @click="syncOaDeptInfo" v-hasPermi="['system:user:sync:org']" @load="orgLoading">同步组织架构</a-button>
        <a-button @click="$refs.syncModal.show()" v-hasPermi="['system:user:sync:user']" @load="syncLoading">同步oa员工</a-button>
      </lsStatusButton>
    </template>
    <div slot="table">
      <ls-api-table
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        :selectedRows.sync="selectedRows"
        :multi-select="true"
        rowKey="userId"
        :scroll="{ fixScreen: true, x: 1300 }"
        @selectedRowChange="selectedRowChange"
        :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.USER_LIST, // 表格方案配置唯一值
              }"
      >
        <template slot="phonenumber" slot-scope="{ text }">
          <span v-if="text!=''">{{ text.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') }}</span>
          <span v-if="text==''">{{ text.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') }}</span>
        </template>
        <template slot="status" slot-scope="{ text }">
          <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />
          <!-- <a-popconfirm
            ok-text="是"
            cancel-text="否"
            @confirm="confirmHandleStatus(record)"
            @cancel="cancelHandleStatus(record)"
          >
            <span slot="title">确认<b>{{ record.status === '1' ? '启用' : '停用' }}</b>名称为:{{ record.nickName }}的用户吗?</span>
            <a-switch :checked="record.status == 0" />
          </a-popconfirm> -->
        </template>
        <!-- <template slot="action" slot-scope="{ text, record }">
          <a @click="$refs.createModal.show(record)" v-hasPermi="['system:user:edit']">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="resetPwd(record.userId)">重置密码</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" v-if="record.userId !== 1" v-hasPermi="['system:user:remove']" @click="deleteRecord(record)">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template> -->
      </ls-api-table>
      <!-- 创建/编辑用户,单独封装了组件 -->
      <create-form
        ref="createModal"
        @handle-success="onSearch"
      />
      <!-- 同步用户,单独封装了组件 -->
      <sync-form
        ref="syncModal"
        @handle-success="onSearch"
      />
      <!-- 修改密码抽屉 -->
      <reset-password
        ref="resetPassword"
        :visible="resetPasswordVisible"
        :loading="resetPasswordConfirmLoading"
        :model="resetPasswordmdl"
        @cancel="resetPasswordHandleCancel"
        @ok="resetPasswordHandleOk"
      />
      <!-- 上传文件 -->
      <a-modal
        :title="upload.title"
        :visible="excelVisible"
        @cancel="importExcelHandleCancel"
      >
        <a-upload-dragger
          name="file"
          accept=".xlsx, .xls"
          :multiple="true"
          :headers="upload.headers"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          @change="importExcelHandleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            请将文件拖拽到此处上传
          </p>
          <p class="ant-upload-hint">
            支持单个或批量上传，也可以点击后选择文件上传
          </p>
        </a-upload-dragger>
      </a-modal>
    </div>
  </lsTableLayout>
</template>

<script>
import { listUser, resetPwd, delUser, changeUserStatus, syncOaDeptInfo } from '@/api/system/user'
import ListSearchForm from './components/ListSearchForm'
import CreateForm from './components/CreateForm'
import SyncForm from './components/SyncForm'
import DeptTree from './components/DeptTree'
import ResetPassword from './components/ResetPassword'
import { treeselect } from '@/api/system/dept'
import { generateLsTableResData } from '@/utils/util.js';
import Cookies from 'js-cookie';

const statusMap = {
  0: {
    status: 'default',
    text: '停用'
  },
  1: {
    status: 'processing',
    text: '正常'
  }
}

export default {
  name: 'User',
  components: {
    CreateForm,
    SyncForm,
    ResetPassword,
    DeptTree,
    ListSearchForm
  },
   data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(listUser, true),
        pageCurrent: true
      },
      // 表头
      columns: [
        {
          title: '用户编号',
          dataIndex: 'userId',
          scopedSlots: { customRender: 'userId' }
        },
        {
          title: '用户名',
          dataIndex: 'userName'
        },
        {
          title: '用户名称',
          dataIndex: 'nickName'
        },
        {
          title: '部门',
          dataIndex: 'dept.deptName'
        },
        {
          title: '手机号码',
          dataIndex: 'phonenumber',
          scopedSlots: { customRender: 'phonenumber' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '创建时间',
          width: 200,
          dataIndex: 'createTime'
        }
        // {
        //   title: '操作',
        //   width: '150',
        //   dataIndex: 'action',
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      // 部门树选项
      deptOptions: [{
        id: 0,
        label: '暂无部门',
        children: []
      }],
      // 部门默认展开
      expandedKeys: [],
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/system/user/importData'
      },
      // 重置密码
      resetPasswordVisible: false,
      resetPasswordConfirmLoading: false,
      resetPasswordmdl: null,
      resetPassswordUserId: 0,
      user: {},
      orgLoading: false,
      syncLoading: false,
      // 表格数据
      data: [],
      form: null,
      // 查询参数
      queryParam: {
        // status: '0'
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  mounted () {
    this.onSearch();
  },
  created () {
    this.getTreeselect()
  },
  // 状态过滤
  filters: {
    statusFilter (type) {
      return statusMap[type].text
    },
    statusTypeFilter (type) {
      return statusMap[type].status
    }
  },
  methods: {
    // 表单搜索
    onSearch (values = {}) {
      const params = { ...values };
      delete params.searchFormLabel;
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    // 删除
    deleteRecord (record) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 ${record.nickName} 吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.handleDelete([record.userId], {
            success () {},
            done () {}
          })
        }
      })
    },
    // 批量删除
    batchDelete (ids) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除这 ${ids.length} 位用户吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.handleDelete(ids, {
            success () {},
            done () {}
          })
        }
      })
    },
    // 发送删除行为
    handleDelete (ids, callback) {
      if (ids.length > 0) {
        delUser(ids).then(response => {
          if (response.code === 200) {
            this.$message.success('删除成功!')
            this.onSearch();
          } else {
            this.$message.error(response.msg)
          }
        })
      }
    },
    resetPasswordHandleCancel () {
      this.resetPasswordVisible = false
    },
    // 动态操作(打开重置密码)
    resetPwd (id) {
      this.resetPassswordUserId = id
      this.resetPasswordmdl = null
      this.resetPasswordVisible = true
    },
    // 重置密码提交事件
    resetPasswordHandleOk () {
      const form = this.$refs.resetPassword.form
      this.resetPasswordConfirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
            // 新增
            new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve()
              }, 1000)
            }).then(res => {
              resetPwd(Object.assign({
                'userId': this.resetPassswordUserId,
                'password': values.password
              })).then(res => {
                if (res.code === 200) {
                  this.$message.success(res.msg)
                  // 重置表单数据
                  form.resetFields()
                  this.resetPasswordVisible = false
                  this.resetPasswordConfirmLoading = false
                } else {
                  this.$message.error(res.msg)
                }
              })
            })
        } else {
          this.resetPasswordConfirmLoading = false
        }
      })
    },
    /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    /** 同步组织架构 */
    syncOaDeptInfo () {
      this.orgLoading = true;
      syncOaDeptInfo().then(() => {
        this.orgLoading = false;
        this.$message.success('同步成功');
      });
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.download('system/user/export', {
        ...this.queryParams
      }, `用户数据库_${new Date().getTime()}.xlsx`)
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('system/user/importTemplate', {
        ...this.queryParams
      }, `用户导入模板_${new Date().getTime()}.xlsx`)
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.onSearch();
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    clickDeptNode (deptId) {
      this.onSearch({ deptId: deptId });
    },
    /** 查询部门下拉树结构 */
    getTreeselect () {
      treeselect().then(response => {
        this.deptOptions = response.data
        if (this.deptOptions) {
            this.expandedKeys = [this.deptOptions[0].id, this.deptOptions[0].children[0].id]
        }
      })
    },
    /* 任务状态修改 */
    confirmHandleStatus (row) {
      row.status = row.status === '0' ? '1' : '0'
      const text = row.status === '0' ? '启用' : '停用'
      changeUserStatus(row.userId, row.status)
      .then(() => {
        this.$message.success(
          text + '成功',
          3
        )
      }).catch(function () {
        this.$message.error(
          text + '发生异常',
          3
        )
      })
    },
    cancelHandleStatus (row) {
    }
  }
}
</script>
